import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './vaanmathi/Home';
import Terms from './vaanmathi/terms';
import PrivacyPolicy from './vaanmathi/PrivacyPolicy';
import DriverEmail from './vaanmathi/driveremail';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/deactivateaccount" element={<DriverEmail/>}/>
        </Routes>
      </div>
    </Router>
  );
}

export default App;